"use client";

import type React from "react";
import { useRouter } from "next/navigation";
import { EventType, trackEventWithCommonProps } from "@utils/eventTracker";
import type { PageType } from "@constants/pageTypes";
import { useGlobalLoader } from "@hooks/useGlobalLoader";

interface AppTrackedAnchorProps {
  href: string;
  className?: string;
  pageType?: PageType;
  eventProperties: Record<string, unknown>;
  children: React.ReactNode;
}

export default function AppTrackedAnchor({
  href,
  className,
  pageType,
  eventProperties,
  children,
}: AppTrackedAnchorProps) {
  const router = useRouter();
  const { showLoader } = useGlobalLoader();

  const handleClick = async (event: React.MouseEvent<HTMLAnchorElement>) => {
    if (
      event.defaultPrevented ||
      event.button !== 0 ||
      event.metaKey ||
      event.ctrlKey ||
      event.shiftKey ||
      event.altKey
    ) {
      return;
    }

    event.preventDefault();
    showLoader("Loading...");
    await trackEventWithCommonProps("action", EventType.TRACK_EVENT, {
      pageType,
      additionalProps: eventProperties,
    });
    router.push(href);
  };

  return (
    <a className={className} href={href} onClick={handleClick}>
      {children}
    </a>
  );
}
